import {Action, action, Computed, computed} from 'easy-peasy';
import {MatchResult} from 'routing/utils/types';

export interface ActivePageStoreModel {
    activeMatch: MatchResult;
    activeRoute: Computed<ActivePageStoreModel, string>;
    activePath: Computed<ActivePageStoreModel, string>;
    setActiveMatch: Action<ActivePageStoreModel, MatchResult>;
    activeRouteName: null | string;
    setActiveRouteName: Action<ActivePageStoreModel, string>;

    initialPathname: string;
}

export default <ActivePageStoreModel>{
    activeMatch: {},
    activeRoute: computed(
        ({activeMatch}) => activeMatch?.path ?? '',
    ),
    activePath: computed(
        ({activeMatch}) => activeMatch?.uri ?? '',
    ),
    setActiveMatch: action((state, match) => {
        state.activeMatch = match;
    }),
    activeRouteName: null,
    setActiveRouteName: action((state, route) => {
        state.activeRouteName = route;
    }),

    initialPathname: window.location.pathname,
};
